import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const menuItems = [
  { path: '/dashboard', label: '대시보드', icon: '📊' },
  { path: '/accounts', label: '계좌 관리', icon: '👥' },
  { path: '/a-book', label: 'A북 현황', icon: '🔴' },
  { path: '/statistics', label: '통계', icon: '📈' },
  { path: '/pattern', label: '패턴 분석', icon: '🧠' },
];

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      {/* Sidebar */}
      <div style={styles.sidebar}>
        <div style={styles.sidebarHeader}>
          <div style={styles.logo}>AB</div>
          <div>
            <div style={styles.logoTitle}>AB Book</div>
            <div style={styles.logoSub}>Hybrid System</div>
          </div>
        </div>

        <nav style={styles.nav}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                style={isActive ? { ...styles.navItem, ...styles.navItemActive } : styles.navItem}
                onClick={() => navigate(item.path)}
              >
                <span style={styles.navIcon}>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div style={styles.sidebarFooter}>
          <div style={styles.userInfo}>
            <div style={styles.userAvatar}>{user?.name?.[0] || 'A'}</div>
            <div>
              <div style={styles.userName}>{user?.name || 'Admin'}</div>
              <div style={styles.userRole}>{user?.role || 'SUPER'}</div>
            </div>
          </div>
          <button style={styles.logoutBtn} onClick={handleLogout}>로그아웃</button>
        </div>
      </div>

      {/* Main Content - 100% 너비 */}
      <div style={styles.main}>
        <div style={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex', minHeight: '100vh',
    background: '#0f0f1a', fontFamily: "'Pretendard', -apple-system, sans-serif",
  },
  sidebar: {
    width: '220px', minHeight: '100vh',
    background: 'rgba(255,255,255,0.03)',
    borderRight: '1px solid rgba(255,255,255,0.08)',
    display: 'flex', flexDirection: 'column', padding: '24px 16px',
    position: 'fixed', top: 0, left: 0, bottom: 0,
    zIndex: 100,
  },
  sidebarHeader: {
    display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '36px', padding: '0 8px',
  },
  logo: {
    width: '40px', height: '40px', background: 'linear-gradient(135deg, #667eea, #764ba2)',
    borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '16px', fontWeight: 800, color: '#fff', flexShrink: 0,
  },
  logoTitle: { color: '#fff', fontSize: '16px', fontWeight: 700 },
  logoSub: { color: 'rgba(255,255,255,0.4)', fontSize: '11px' },
  nav: { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 },
  navItem: {
    display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px',
    borderRadius: '10px', border: 'none', background: 'transparent',
    color: 'rgba(255,255,255,0.5)', fontSize: '14px', cursor: 'pointer',
    textAlign: 'left', width: '100%', transition: 'all 0.2s',
  },
  navItemActive: {
    background: 'rgba(102,126,234,0.2)', color: '#667eea',
    fontWeight: 600,
  },
  navIcon: { fontSize: '16px', width: '20px', textAlign: 'center' },
  sidebarFooter: {
    borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '16px', marginTop: '16px',
  },
  userInfo: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', padding: '0 4px' },
  userAvatar: {
    width: '32px', height: '32px', background: 'linear-gradient(135deg, #667eea, #764ba2)',
    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', fontSize: '14px', fontWeight: 700, flexShrink: 0,
  },
  userName: { color: '#fff', fontSize: '13px', fontWeight: 600 },
  userRole: { color: 'rgba(255,255,255,0.4)', fontSize: '11px' },
  logoutBtn: {
    width: '100%', padding: '8px', background: 'rgba(255,77,77,0.1)',
    border: '1px solid rgba(255,77,77,0.2)', borderRadius: '8px',
    color: '#ff6b6b', fontSize: '13px', cursor: 'pointer',
  },
  // 사이드바 제외한 전체 너비 사용
  main: {
    marginLeft: '220px',
    flex: 1,
    minHeight: '100vh',
    overflow: 'auto',
  },
  content: {
    padding: '32px',
    width: '100%',
    boxSizing: 'border-box' as const,
  },
};

export default Layout;
